export { AUTH_ROUTES, AUTH_ROUTES_PATHS } from './auth-routes';
export { LANDING_ROUTES, LANDING_ROUTES_PATHS } from './landing-routes';
export { HF_ROUTES, HF_ROUTES_PATHS } from './hf-routes';

export const TERMS_AND_CONDITIONS = '#terms-and-conditions';
export const PRIVACY_POLICY = '#privacy-policy';
